import { styled } from '@mui/material';

export const Container = styled('div')({
  margin: '20px 0',
  display: 'grid',
  gridTemplateColumns: '1fr 328px',
  gap: '16px 16px',

  '& .feedback': {
    padding: '0px !important',
    margin: '0px -10px !important'
  },
  '& .dot-sepatared-title': {
    fontWeight: 400,
    fontSize: 12,
    color: '#7D7D7D',
    '& .dot-sepatared-title-left': {
      fontWeight: 400
    }
  }
});

export const InfoTitle = styled('h4')({
  fontSize: 12,
  fontWeight: 400,
  marginTop: 16,
  marginBottom: 2,
  color: 'rgba(125, 125, 125, 1)'
});

export const Phone = styled('div')({
  marginBottom: 2,
  '& a': {
    textDecoration: 'underline',
    color: '#0675DD'
  }
});

export const Balance = styled('div')({
  marginTop: 25,
  display: 'flex',
  alignItems: 'center',
  '& svg': {
    width: 18,
    height: 18,
    padding: 2,
    color: '#E31B0C',
    backgroundColor: '#FAE4E3',
    borderRadius: 4,
    marginRight: 4
  }
});

export const VisitList = styled('ul')({
  margin: 0,
  padding: 0,
  color: '#000',

  '& li': {
    margin: '0px !important',
    listStyle: 'none'
  },
  '& li + li': {
    borderTop: '1px solid #E9EAEE'
  },
  '& .past-appointment-title': {
    fontWeight: 400,
    fontSize: 12,
    color: '#7D7D7D'
  },
  '& .spent-chip': {
    padding: '2px 8px'
  },
  '& .upcoming-appointment-item': {
    border: '1px solid #E9EAEE',
    backgroundColor: '#FCFCFC',
    borderRadius: 4,
    padding: '0px !important',
    '& .icon': {
      background: 'transparent',
      border: '1px solid rgba(161, 174, 187, 0.5)'
    },
    '& .list-item': {
      alignItems: 'center'
    }
  }
});

export const ButtonsRight = styled('div')({
  marginTop: 4,
  display: 'flex',
  justifyContent: 'flex-end',
  '& button': {
    marginLeft: 16,
    color: '#0675DD',
    '&:disabled': {
      color: '#A1AEBA',
      cursor: 'default',
      textDecoration: 'none'
    }
  }
});

export const InsuranceContainer = styled('div')({
  height: 30
});
